import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class clearLocalStorageExceptLastLoginService {
  clearLocalStorageExceptLastLogin() {
    // Lưu lại các giá trị cần giữ
    const lastUsername = localStorage.getItem('lastUsername');
    const lastPassword = localStorage.getItem('lastPassword');

    // Xóa tất cả localStorage
    localStorage.clear();

    // Đặt lại giá trị cần giữ
    if (lastUsername) {
      localStorage.setItem('lastUsername', lastUsername);
    }
    if (lastPassword) {
      localStorage.setItem('lastPassword', lastPassword);
    }
  }
}
